///<reference types="facebook-js-sdk" />
import { HttpErrorResponse } from '@angular/common/http';
import { Component, ElementRef } from '@angular/core';
import { TOAST } from '@commoncore/constants/ToastMessages';
import { HTML_ERRORS } from '@commoncore/constants/htmlErrors';
import { AppEvents } from '@commoncore/utils/app-events';
import { ENV_CONSTANTS } from '@env-properties/environment';
import { ENV_CONFIG } from '@env-properties/environment-config';
import { DEFAULT_USER_DETAILS, USER_DETAILS } from '@mainrepo/app/core/constants/Constants';
import { PasswordEncryptorUtil } from '@mainrepo/app/core/utils/PasswordEncryptorUtil';
import * as EmailValidator from "email-validator";
import { interval } from 'rxjs';
import { GlobalClassInstance } from '../constants/GlobalClass';
import { BANNER_CONSTANTS } from '../constants/bannerConstants';
import { LoginExceptions } from '../exception/LoginExceptions';
import { CleverTapEventsService } from '../services/clevertap-events-service';
import { GlobalService } from '../services/global.service';
import { LocalStorageSvc } from '../services/localStorage.service';
import { ActiveRepo, UniversalService } from '../services/universal.service';
declare var AppleID;
// import { AuthService, FacebookLoginProvider, GoogleLoginProvider } from 'angularx-social-login';
// import { FacebookLoginProvider, GoogleLoginProvider } from '@abacritt/angularx-social-login';
import { LocalStorageProps } from '@commoncore/enums/localStorageProps';
import versionData from 'assets/JSON/appVersion.json';

@Component({
	template: ''
  })
export class UserLoginImplementation {
	public universalService: any;
	public exception: any;
	public router: any;
	public http: any;
	public qrDeviceKey:any;
	public qrImageUrl:any;
	public qrCodeInvalid : boolean = false;
	public refreshQRCode : boolean = false;	
	public isOTPLoginError:boolean = false;
	public enteredOtp: any;
  	public OTPTimer:number=30;
	public showTimer:boolean = false;
	lastRefreshTime:any
	public enableButton:boolean = false;
	public passwordEncryptorUtil:any;
	private localStorageSvc: LocalStorageSvc;
	loggerService: any;
	public listService: any;
	mobileNumber: string;
	emailId: string;
	cleverTapEventsService: CleverTapEventsService;
	sessionStorageService: any;
	public isPassPhraseLoginError:boolean = false;
	invalidPassPhraseCounter:any = ENV_CONSTANTS["constants"]["passPhraseattempts"];
	enablePassPhraseSubmitButton: boolean = false;
	decryptedPassPhraseSessionKey: any;
	troubledLoginMobileNo: any;
    showTrobledSigninModalToUsr : boolean = false;
	troubledLoginResopose:any;
	showSendOtpModal:boolean = false;
	noMappingFoundModal: boolean = false;
	reqIdFromResponseHeader:any = '';
	static singleInstance:any = null;
	versionDetails:any;
	is2FAForPrivateFolder:boolean = false;
	invalidPassPhrase:boolean = false;
	public isIDAMLoginError:boolean = false;
	deviceService: any;

  constructor(public globalService:GlobalService) {
		this.exception = new LoginExceptions(globalService);
		this.passwordEncryptorUtil=new PasswordEncryptorUtil();
		// this.isOTPLoginError= false;	
		this.router = this.globalService.getRouterRef();
		this.http=globalService.getHttpClientRef();
		this.universalService=globalService.getUniversalServiceRef();
		this.loggerService = globalService.getLoggerServiceRef();
		this.localStorageSvc = this.globalService.getLocalStorageSvcRef();
		this.listService = globalService.getListServiceRef();
		this.cleverTapEventsService = globalService.getCleverTapEventsvc();
		this.sessionStorageService = globalService.getSessionStorageSvcRef();
		this.deviceService =  globalService.getDeviceServiceRef();
	}


	public static getInstance(globalService):UserLoginImplementation{
		if(this.singleInstance == null){
		  this.singleInstance = new UserLoginImplementation(globalService);
		  return this.singleInstance;
		}else{
		  return this.singleInstance;
		}
	  }
	blankCheck(screen:any,id:any,password:any){
		this.exception.blankCheck(screen,id,password);
	}

	public encrypt(password){
		return this.passwordEncryptorUtil.encryptPassword(password);
	}

	validateOTP(fromId, toId, e,id="digit") {
		this.isOTPLoginError = false;
		var inputs: any = [];
		let otpGroup = "otp" + id + "[]";
		inputs = document.getElementsByName(otpGroup);
		this.OTPLoginValidation(inputs);
		if (fromId != id + "6") {
		  var ele = (<HTMLInputElement>document.getElementById(fromId)).value;
		  if (ele.length == 1) {
			let nextEl = (<HTMLInputElement>document.getElementById(toId));
			nextEl.focus();
		  }
		}
		
		if (fromId != id + "1") {
		  if (e.keyCode == 8 || e.keyCode == 46) {
			(<HTMLInputElement>document.getElementById(fromId)).value = "";
			var element = <HTMLInputElement>document.getElementById(fromId);
			element.getAttribute("data-previous");
			document.getElementById(element.getAttribute("data-previous")).focus();
		  }
		}
	}

	moveToNextElement(event, nextId?:string){
		let allowedKeys = ["1","2","3","4","5","6","7","8","9","0"]
		if (!allowedKeys.includes(event.key)) {
			return;
		}
		let object = event.target;
		let nextEl = (<HTMLInputElement>document.getElementById(nextId));
		var regex = /^[0-9]+$/ ;
		if (object.value.length == object.maxLength) {
		  if( nextEl && nextEl.value == '' && event.keyCode != 8){
			nextEl.focus();
			nextEl.value = event.key;
			// if(object.value.match(regex)){
			// 	nextEl.value = '';
			// }
			return false;
		  } else {
			return true;
		  }
		}
		else {
		  return true;
		}
	  
	}	
	public  socialLogin(serviceUrl: string,socialplatform:String,browser: any,browserVersion: any,authProviderId:any,authToken:any) {
		var classRef = this;
		return new Promise(async function(resolve, reject){
			let socialPlatformProvider: string;
			// if (socialplatform === 'facebook') {  
			// 	socialPlatformProvider = FacebookLoginProvider.PROVIDER_ID;  
			// } else if (socialplatform === 'google') {  
			// 	socialPlatformProvider = GoogleLoginProvider.PROVIDER_ID;  
			// }  
			if(socialplatform == "apple"){
				try {
					AppleID.auth.init({
							  clientId : ENV_CONSTANTS.appleAppId,
							  scope : 'name email',
							  redirectURI : ENV_CONSTANTS.appleRedirectUrl,
							   state : 'sign in',
							//   nonce : 'test',
							  usePopup : true 
					});

					await AppleID.auth.signIn().then(async (userData) => {
							let firstName = "";
							let lastName = "";
							if(userData.user!=undefined){
								firstName = userData.user.firstName
								lastName = userData.user.lastName
							}
							
							classRef.universalService.showLoader = true;
							let params  = {     
								"authProviderId": authProviderId,
								"authProviderToken":userData.authorization.code,
								"firstName":firstName, 
								"lastname" : lastName,
								"externalId": classRef.parseJwt(userData.authorization.id_token).sub,
								"encToken" : userData.authorization.id_token,
								"deviceType": "W",
								"userType":"T",
								"deviceInfo": {
									"model": "browser",
									"deviceName": "Web Device",
									"platformType": browser,
									"platformVersion": browserVersion,
									"type": "browser",
									"isWebClient": true
								},
								'isStaySignIn': true,
							}
							let result= await classRef.socialLoginApi(serviceUrl,params,socialplatform);
							resolve(result);
					});
				} catch (error) {
					console.log(error)
					reject(error);
				}
			}else{
				var params = classRef.getSocialLoginPayLoad(authProviderId,authToken,browser,browserVersion);
				if(socialplatform == "facebook"){

					// FB Login using SDK
					FB.init({
						appId      : ENV_CONSTANTS['fbAppId'], 
						cookie : true,
						version    : 'v18.0'
					});
					FB.login(async function(fbResponse) {
						if (fbResponse.authResponse) {
							try{
								params["authProviderToken"] = fbResponse.authResponse.accessToken;
								let result = await classRef.socialLoginApi(serviceUrl, params, socialplatform);
								resolve(result);
							}catch(e){
								reject(e);
							}
						} else {
							classRef.universalService.showLoader = false;
						}
					});

					//FB login using Library
					// socialLoginAuthService.signIn(socialPlatformProvider).then(async (userData) => {
					// 	params["authProviderToken"] = userData["authToken"];
					// 	try{
					// 		let result=await classRef.socialLoginApi(serviceUrl,params,socialplatform);
					// 		resolve(result);
					// 	}catch(e){
					// 		reject(e);
					// 	}
					// });
				}else{
					try{
						let result=await classRef.socialLoginApi(serviceUrl,params,socialplatform);
						resolve(result);
					}catch(e){
						reject(e);
					}
				}
			}
			
		});
	}


	parseJwt (token) { 	
		var base64Url = token.split('.')[1];
		var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
		var jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
			return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
		}).join(''));
		return JSON.parse(jsonPayload);
	}

	getSocialLoginPayLoad(authProviderId,authToken,browser,browserVersion){
		var classRef = this;
		classRef.universalService.showLoader = true;
		let params  = {     
				"authProviderId": authProviderId,
				"deviceType": "W",
				"userType":"T",
				"authProviderToken":authToken,
				"deviceInfo": {
					"model": "browser",
					"deviceName": "Web Device",
					"platformType": browser,
					"platformVersion": browserVersion,
					"type": "browser",
					"isWebClient": true
				},
				'isStaySignIn': true,
			}
		return params;
	}

	public  socialLoginApi(serviceUrl, params,socialplatform){
		var classRef = this;
		return new Promise(function(resolve, reject){
			classRef.http.post(serviceUrl,params,{observe: 'response'}).subscribe(
				async suc => {
					classRef.setUserDetails(suc.body,suc.headers.get("User-Device"));
					if(socialplatform == "apple") {
						// classRef.cleverTapEventsService.appleLoginMode();
					} else if(socialplatform == "facebook") {
						classRef.cleverTapEventsService.facebookLoginMode();
					} else if(socialplatform == "google") {
						classRef.cleverTapEventsService.googleLoginMode();
					} 
					// else {
					// 	classRef.cleverTapEventsService.socialLoginMode();	
					// }
					classRef.cleverTapEventsService.loginStatus();
					classRef.disableSocialMoreOptions();
					await classRef.check2FAStatus(suc.body.isTwoFAEnabled);
					resolve(suc);// new Date().getTime()
				},
				err => {
					classRef.universalService.showLoader = false;
					// classRef.exception.handleLoginError("OTP",err);
					AppEvents.loginSubscriptions.next({'otherloginoptions':false});
					AppEvents.loginSubscriptions.next({'showerroronsigninscreen':true});
					classRef.isOTPLoginError= true;
					classRef.exception.handleLoginError(socialplatform,err);
					reject(err);
					// if(classRef.universalService.idamLogin){
					// 	classRef.isIDAMLoginError = true;
					// }
					// else{
					// 	classRef.isOTPLoginError = true;
					// }
					// classRef.exception.handleLoginError(socialplatform,err);
					// reject(err);
				}
			)
		})
	}
	disableSocialMoreOptions() {
		jQuery("#overlay-more-login-options-mobile").css({'transition':'all ease 1s', 'display':'none', 'visibility':'hidden', 'opacity':'0'});
		jQuery("#mobile-more-options").css({'bottom':'-1000px', 'transition':'all ease 1s', 'visibility':'hidden', 'opacity':'0'});
	  }

	verifyJioIdOTP(url,mobileNumber,otp){
		var classRef = this;
		let params = {
			mobileNumber : mobileNumber,
			otp : otp
		}
		return new Promise(function(resolve, reject){
			classRef.http.post(url, params).subscribe(
				suc=>{
					classRef.universalService.showLoader = false;
					suc["userAccounts"].map(acc=>{
						acc["requestId"] = suc["requestId"]
					});
					resolve({"accountsList" : suc["userAccounts"]});
				},error=>{
					classRef.universalService.showLoader = false;
					classRef.exception.handleLoginError('OTP', error);
          			AppEvents.loginSubscriptions.next({"enterotperror":true,"message":classRef.exception.errorMessage});
					reject(false);
				},
			);
		})
	}

	validateJioMartSSOToken(url,ssoToken,jiomartToken,txnId){
		var classRef = this;
		let params = {
			authProviderToken : ssoToken,
			"tkn" : jiomartToken,
          	"tnxId":txnId,
		}
		return new Promise(function(resolve, reject){
			classRef.http.post(url, params).subscribe(
				suc=>{
					suc["userAccounts"].map(acc=>{
						acc["requestId"] = suc["requestId"]
					});
					resolve({"accountsList" : suc["userAccounts"]});
				},error=>{
					classRef.exception.handleLoginError("jioid",error);
					reject(false);
				},
			);
		})
	}


	jioIdLogin(serviceUrl,accountDetails,browser,browserVersion,staySignedIn){
		var classRef = this; 
		return new Promise(async function(resolve, reject){
			classRef.universalService.showLoader = true;
			let params  = {
				"userId":accountDetails["userId"],
				"requestId": accountDetails["requestId"],
				"deviceType": "W",
				"mobileNumber": accountDetails["phoneNumber"],
				"deviceInfo": {
					"model": "browser",
					"deviceName": "Web Device",
					"platformType": browser,
					"platformVersion": browserVersion,
					"type": "browser",
					"isWebClient": true
				},
				'isStaySignIn': staySignedIn,
			}
			
			try{
				let result = await classRef.jioIdLoginApi(serviceUrl,params);
				resolve(result);
			}catch(e){
				reject(false);
			}	
		})
	}

	public  jioIdLoginApi(serviceUrl, params){
		var classRef = this;
		return new Promise(function(resolve, reject){
			classRef.http.post(serviceUrl, params,{observe: 'response'}).subscribe(
				async (suc) => {
					suc.body["loginType"] = "Jio Id";
					classRef.localStorageSvc.removeLocalProperty(LocalStorageProps.JC_JWT)
					classRef.setUserDetails(suc.body,suc.headers.get("User-Device"));
					await classRef.check2FAStatus(suc.body.isTwoFAEnabled)
					if(suc.body.jcJWT!=undefined){
						classRef.localStorageSvc.setLocalProperty (LocalStorageProps.JC_JWT,suc.body.jcJWT,false)
					}
					resolve(suc);// new Date().getTime()		
				},
				(error:HttpErrorResponse) => {
					classRef.exception.handleLoginError("OTP",error);
					let errMessage = classRef.exception.errorMessage;
					classRef.universalService.showToast(errMessage,"error");
					if(!classRef.router.url.includes("/waves")){
						AppEvents.loginSubscriptions.next({"jioidlogin":true});
					}
					reject(false);
				},
			);
		})
	}


	jioMartLogin(serviceUrl,accountDetails,browser,browserVersion,platform){
		var classRef = this;
		return new Promise(async function(resolve, reject){
			classRef.universalService.showLoader = true;
			let params  = {
				"tkn" : accountDetails["jiomartToken"],
				"tnxId": accountDetails["transactionId"],
				"userId":accountDetails["userId"],
				"requestId": accountDetails["requestId"],
				"deviceType": "W",
				"mobileNumber": accountDetails["phoneNumber"],
				"deviceInfo": {
					"model": "browser",
					"deviceName": "Web Device",
					"platformType": browser,
					"platformVersion": browserVersion,
					"type": "browser",
					"isWebClient": true
				},
			}
			
			try{
				let result = await classRef.jioMartLoginApi(serviceUrl,params,platform);
				resolve(result);
			}catch(e){
				reject(false);
			}	
		})
	}

	public jioMartLoginApi(serviceUrl, params,platform){
		var classRef = this;
		return new Promise(function(resolve, reject){
			classRef.http.post(serviceUrl, params).subscribe(
				async (suc) => {
					resolve(suc);
				},
				(error:HttpErrorResponse) => {
					classRef.exception.handleLoginError(platform,error);
					reject(false);
				},
			);
		})
	}

	jiocloudpcLogin(serviceUrl,token,authProviderId,browser,browserVersion,platform){
		var classRef = this;
		return new Promise(async function(resolve, reject){
			classRef.universalService.showLoader = true;
			let params  = {     
				"authProviderId": authProviderId,
				"deviceType": "W",
				"userType":"T",
				"jwtToken":token,
				"deviceInfo": {
					"model": "browser",
					"deviceName": "Web Device",
					"platformType": browser,
					"platformVersion": browserVersion,
					"type": "browser",
					"isWebClient": true
				},
				'isStaySignIn': true,
			}
			
			try{
				let result = await classRef.jiocloudpcLoginApi(serviceUrl,params,platform);
				resolve(result);
			}catch(e){
				reject(e);
			}	
		})
	}

	public  jiocloudpcLoginApi(serviceUrl, params,platform){
		var classRef = this;
		return new Promise(function(resolve, reject){
			classRef.http.post(serviceUrl, params,{observe: 'response'}).subscribe(
				async (suc) => {
					suc.body["iframeLogin"] = true;
					classRef.universalService.iframeLogin = true;
					classRef.setUserDetails(suc.body,suc.headers.get("User-Device"));
					await classRef.check2FAStatus(suc.body.isTwoFAEnabled);
					resolve(suc);		
				},
				(error:HttpErrorResponse) => {
					reject(error);
				},
			);
		})
	}

	/**To get an new OTP */


	validateOtpLoginInput(otpInput,validationType) {
		if(!this.universalService.connectionStatus){
			this.isOTPLoginError = true;
			this.exception.errorMessage = HTML_ERRORS["NETWORK_CONNECTION_ERR"];	
			return;
		}
		const otpInputValue = otpInput?.nativeElement?.value ? otpInput?.nativeElement?.value : otpInput.nativeElement?otpInput.nativeElement:otpInput;
		if(validationType == "email"){
			if (otpInputValue.length == 0) {
			this.enableButton = false;
			this.isOTPLoginError = true;
			this.exception.errorMessage = HTML_ERRORS["INVALID_EMAIL"];
			this.universalService.showTroubledSignInLink = false;
			} else{
				this.validateEmailId(otpInputValue);
			}
		} else {
			this.validateMobileNumber(otpInputValue);
		} 
	}
	
	validateMobileNumber(mNumber) {
		var regex = /^(\+)?[0-9]+$/;
		if (mNumber == "") {
		  this.enableButton = false;
		  this.isOTPLoginError = true;
		  this.universalService.showTroubledSignInLink = false;
		  this.exception.errorMessage = HTML_ERRORS["INVALID_MOB_NO"];
		} else if (!mNumber.match(regex)) {
		  this.enableButton = false;
		  this.isOTPLoginError = true;
		  this.universalService.showTroubledSignInLink = false;
		  this.exception.errorMessage = HTML_ERRORS["INVALID_MOB_NO"];
		}  //else if ( (mNumber.startsWith("+91") && mNumber.length !=13) || (mNumber.startsWith("0091") && mNumber.length !=14) || (!mNumber.startsWith("+") && !mNumber.startsWith("00") && mNumber.length !=10)) 
		else if ( (mNumber.startsWith("+91") && mNumber.length !=13)  || (!mNumber.startsWith("+")   && mNumber.length !=10)) {
		  this.enableButton = false;
		  this.isOTPLoginError = true;
		  this.universalService.showTroubledSignInLink = false;
		  this.exception.errorMessage = HTML_ERRORS["INVALID_MOB_NO"];
		}else if( (mNumber.startsWith("+910") && mNumber.length ==13) ||  (!mNumber.startsWith("+") && mNumber.startsWith("0") && mNumber.length ==10) ||  (mNumber.startsWith("+") && mNumber.length ==10) ){ 
			this.enableButton = false;
		  	this.isOTPLoginError = true;
		  	this.universalService.showTroubledSignInLink = false;
		  	this.exception.errorMessage = HTML_ERRORS["INVALID_MOB_NO"];
		}//else if( (mNumber.startsWith("+91") && mNumber.length ==13)  ||(mNumber.startsWith("0091") && mNumber.length ==14)||  mNumber.length ==10)
		else if( (mNumber.startsWith("+91") && mNumber.length ==13) ||  (!mNumber.startsWith("+")  && mNumber.length ==10)) { 
			this.enableButton = true;
			this.isOTPLoginError = false;
			this.exception.errorMessage = "";
		}
		if (mNumber.match(regex) && mNumber.length ==13 && mNumber.startsWith("+91"))
			this.mobileNumber = mNumber;
		// else if (mNumber.match(regex) && mNumber.length ==14 && mNumber.startsWith("00"))
		// 	this.mobileNumber = mNumber.replace("00","+");
		else
			this.mobileNumber = "+91" + mNumber;
		this.emailId = "";
	}
	
	validateEmailId(emailId) {
		this.mobileNumber = "";
		if (EmailValidator.validate(emailId)) {
		  this.enableButton = true;
		  this.isOTPLoginError = false;
		  this.exception.errorMessage = "";
		  this.emailId = emailId;
		} else {
		  this.enableButton = false;
		  this.isOTPLoginError = true;
		  this.exception.errorMessage = HTML_ERRORS["INVALID_EMAIL"];
		}
		
	}

	  
	public  validateLoginInput(loginInputEl:ElementRef,validationType) {

		for (var i = 1; i < 7; i++) {
			if (<HTMLInputElement>document.getElementById("digit" + i) != null) {
				(<HTMLInputElement>document.getElementById("digit" + i)).value = "";
			}
		}
		setTimeout(() => {
			(<HTMLInputElement>document.getElementById("digit1"))?.focus();
		}, 1000);
	
		if (this.mobileNumber == undefined || this.emailId == undefined) {
			this.validateOtpLoginInput(loginInputEl,validationType);
		}
		this.isOTPLoginError = false;
		
	}

	public  getOTPApi(serviceUrl: string,validationType,loginInputEl:ElementRef,resend:boolean) { 
		if(!this.universalService.connectionStatus){
			this.isOTPLoginError = true;
			this.exception.errorMessage = HTML_ERRORS["NETWORK_CONNECTION_ERR"];	
			return;
		}
		this.validateLoginInput(loginInputEl,validationType)
		var params = {}
		/*if(this.localStorageSvc.getRecoverData(false)){
			params["emailId"]= this.emailId;
		}else */
		let loginType = "Email"
		if(this.mobileNumber){
			params["mobileNumber"] = this.mobileNumber;
			loginType = "JioId"
		} else {
			params["emailId"]= this.emailId;
		}
		var classRef = this;
		window.clearInterval(classRef.universalService.OtpInterval)
		return new Promise(function(resolve, reject){
			classRef.http.post(serviceUrl, params,{observe: 'response'}).subscribe(
				suc => { 
				if(classRef.router.url.includes('/waves') && classRef.universalService.waveRegister == true ){
					classRef.universalService.waveRegister = false;
				}
				classRef.universalService.showLoader = false;
				if(resend){
					
				}else{
					
				}
				if (suc.body == null) {
					if(resend){
						if(classRef.mobileNumber){
							classRef.universalService.showToast(TOAST["OTP_SENT_SUCCESSFULLY_MOBILE"], "success")
						} else {
							classRef.universalService.showToast(TOAST["OTP_SENT_SUCCESSFULLY"], "success")
						}
					}
					classRef.exception.errorMessage = "";
					var count = 30;
					classRef.OTPTimer = count;

					if(classRef.universalService.isTroubledInSigningInFlowOn){
						classRef.router.navigate(['/signin']);
					}
					AppEvents.loginSubscriptions.next({"enterotp":true,"inputValue":loginInputEl,'page':classRef.universalService.loginType});
					classRef.enableButton = false;
					classRef.showTimer = true;
					classRef.universalService.OtpInterval = setInterval(() => {
						count = count - 1;
						count = count < 0 ? count = 0 : count;
						if (count != 0) {
							classRef.OTPTimer = count;
						} else {
							classRef.showTimer = false;
							classRef.OTPTimer = 0;
							window.clearInterval(classRef.universalService.OtpInterval)
						}
					}, 1000)
				}
				},
				(error:HttpErrorResponse)=>{ 
					classRef.universalService.showLoader = false;
					console.log("error::",error)
					if(classRef.router.url.includes('/waves')){
						AppEvents.loginSubscriptions.next({'waveRegister':true, loginType:loginType, title : "jioIdLogin"});
					}
					classRef.reqIdFromResponseHeader = error.headers.get("X-Request-Id");
					classRef.isOTPLoginError = true;
					if(resend){
						
					}else{
						
					} 
					if(validationType != 'email'){
						AppEvents.loginSubscriptions.next({'showerroronsigninscreen':true}); 
					}
					// setTimeout(()=>{
						classRef.exception.handleLoginError('OTP', error);
					// },400)
					classRef.checkIsTroubleInSigningIn(error,classRef.mobileNumber);
					
				}
			)
		})
		
	}

	public OTPLoginValidation(valueTobeValidated: any) {
		var regex = /^[0-9]+$/ 
		var otpvalue = ""
		var inputs: any = [];
		inputs = valueTobeValidated; // here otp will be any array, as we have 6 input boxes
		for (var i = 0; i < inputs.length; i++) {
			otpvalue = otpvalue + inputs[i].value
		}
		if (otpvalue == "" || !(otpvalue.match(regex)) || (otpvalue.match(regex) && otpvalue.length != 6)) {
			this.enableButton = false;
			this.isOTPLoginError = true;
			this.exception.blankCheck("OTP", "", otpvalue);
		} else {
			this.enableButton = true;
			this.enteredOtp = otpvalue;
		}
	}

	public  otplogin(serviceUrl: string, mobileNumber:any,emailId:any,otp:any,isStaySignIn: any,browser: any,browserVersion: any) {
		var classRef = this;
		this.loggerService.log("otpLogin browserVersion browserVersion ",browserVersion,browserVersion  )
		return new Promise(async function(resolve, reject){
				var params = {
					"mobileNumber": mobileNumber,
					"emailId" : emailId,
					"otp": classRef.enteredOtp,
					"deviceType": "W",
					"deviceInfo": {
						"model": "browser",
						"deviceName": "Web Device",
						"platformType": browser,
						"platformVersion": browserVersion,
						"type": "browser",
						"isWebClient": true
					},
					"isStaySignIn": isStaySignIn
				}
				try{
					let result = await classRef.otploginApi(serviceUrl, params,mobileNumber)
					resolve(result);
				}catch(e){
					reject(false);
				}
		});
	}

	public  otploginApi(serviceUrl, params,mobileNumber){
		var classRef = this;
		return new Promise(function(resolve, reject){
			classRef.http.post(serviceUrl, params,{observe: 'response'}).subscribe(
				async (suc) => { 
					classRef.enableButton = false;
					classRef.localStorageSvc.removeLocalProperty(LocalStorageProps.JC_JWT)
					classRef.setUserDetails(suc.body,suc.headers.get("User-Device"));
					classRef.universalService.customerTroubleLogin = false;
					if(suc.body.jcJWT!=undefined){
						classRef.localStorageSvc.setLocalProperty (LocalStorageProps.JC_JWT,suc.body.jcJWT,false)
					}
					if(mobileNumber && mobileNumber != "") {
						
						classRef.cleverTapEventsService.numberLoginMode();
					} else if(params && params.emailId != "") {
			
						classRef.cleverTapEventsService.emailLoginMode();
					}
					if(suc.body.recoverData){// recover testing || !suc.body.recoverData  
						classRef.universalService.showModalBackdrop();
						classRef.universalService.showLoader = false; 
						classRef.universalService.showRecoverpopUp = true;
						classRef.localStorageSvc.setRecoverDataMobile(mobileNumber, false);
					}else if(!suc.body.recoverData){
						await classRef.check2FAStatus(suc.body.isTwoFAEnabled)
					}
					classRef.cleverTapEventsService.loginStatus();
					// AppEvents.loginSubscriptions.next({"jioidlogin":true});
					resolve(suc);//new Date().getTime()
				
				},
				(error:HttpErrorResponse) => {
					classRef.exception.handleLoginError('OTP', error);
          			AppEvents.loginSubscriptions.next({"enterotperror":true,"message":classRef.exception.errorMessage});
					reject(false);
					
				},
			);
		})	
	}

	getUserDetails(){
		var classRef = this;
		classRef.universalService.showLoader= true;
		const url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["securityURL"]+  ENV_CONFIG.commonUrls["getUserDetails"];
		return new Promise(function(resolve, reject){
			classRef.http.get(url).subscribe(
				(suc) => {
					classRef.universalService.showLoader= false;
					let userData = classRef.localStorageSvc.getUserData(true);
					classRef.isTimeIntervalOverFor2FA(suc);
					suc["privateFolder"] = suc["privateFolder"] ? suc["privateFolder"] : {"isPPFEnabled" : "N", "allowPPF":"D"};
					var moveConfirmationAlreadyAccepted = (userData && userData["privateFolder"]) ? userData["privateFolder"]["moveConfirmationAlreadyAccepted"] : false;
					suc["privateFolder"]["moveConfirmationAlreadyAccepted"] = moveConfirmationAlreadyAccepted ? moveConfirmationAlreadyAccepted : false;
					userData = {
                        ...userData,
                        ...suc
                    };
					userData['isPplTabOn'] = suc['isPplTabOn']?suc['isPplTabOn']:"N";
					userData["allowStoragePurchase"] = suc["allowStoragePurchase"]?suc["allowStoragePurchase"]:"D";
					userData["hasActivePlans"] = ((suc["quota"]["paidPlanQuota"] && suc["quota"]["paidPlanQuota"] != 0 && suc["quota"]["paidPlanQuota"] != null && suc["quota"]["paidPlanQuota"] != undefined) || (suc["paidPlan"] && (suc["paidPlan"]["planStatus"] == 'E' || suc["paidPlan"]["planStatus"] == 'G'))) ? "Y" : "N"
					userData["isFamilyMember"] = suc["isFamilyMember"]?suc["isFamilyMember"]:"N";
					userData["enableFamilyShare"] = suc["enableFamilyShare"]?suc["enableFamilyShare"]:"D";
					userData["quota"]["totalAllocatedQuota"] = suc["quota"]["totalAllocatedQuota"] ? suc["quota"]["totalAllocatedQuota"] : suc["quota"]["allocatedSpace"];
					userData["quota"]["totalUsedQuota"] = suc["quota"]["totalUsedQuota"] ? suc["quota"]["totalUsedQuota"] : suc["quota"]["usedSpace"];
					userData["familyMemberType"] = suc["familyMemberType"]?suc["familyMemberType"]:"";
					userData["familyMembersUsedQuota"] = suc["familyMembersUsedQuota"]?suc["familyMembersUsedQuota"]:"";
					userData["isMandatoryEmail"] = suc["isMandatoryEmail"]?suc["isMandatoryEmail"]:userData["isMandatoryEmail"];
					userData["thirdPartyBackup"]= suc["thirdPartyBackup"]?suc["thirdPartyBackup"] : '';
					userData['digiLocker'] = suc['digiLocker'] ? suc['digiLocker'] : "D";
					userData['eligibleForUpgrade'] = (suc['quotaUpgrade'] && suc['quotaUpgrade']['eligibleForUpgrade']) ? suc['quotaUpgrade']['eligibleForUpgrade'] : "N";
					userData['quotaUpgraded'] = (suc['quotaUpgrade'] && suc['quotaUpgrade']['quotaUpgraded']) ? suc['quotaUpgrade']['quotaUpgraded'] : "N";
					userData["simSearchTwoAi"] = suc["simSearchTwoAi"] ? suc["simSearchTwoAi"] : {"isSimTwoAiEnabled":"N" , "isStatsTwoAiEnabled": "N"};                     
					userData["simSearchTwoAi"]["isSimTwoAiEnabled"] = suc["simSearchTwoAi"]["isSimTwoAiEnabled"] ? suc["simSearchTwoAi"]["isSimTwoAiEnabled"] : "N"; 					
					userData["simSearchTwoAi"]["isStatsTwoAiEnabled"] = suc["simSearchTwoAi"]["isStatsTwoAiEnabled"] ? suc["simSearchTwoAi"]["isStatsTwoAiEnabled"] : "N";                     
					userData["metaSearchTwoAi"] = suc["metaSearchTwoAi"] ? suc["metaSearchTwoAi"] : {"isMetaTwoAiEnabled":"N"};
					userData["metaSearchTwoAi"]["isMetaTwoAiEnabled"] = userData["metaSearchTwoAi"]["isMetaTwoAiEnabled"] ? userData["metaSearchTwoAi"]["isMetaTwoAiEnabled"] : "N";
					userData["metaSearchJc"] = suc["metaSearchJc"] ? suc["metaSearchJc"] : {"isMetaJcEnabled": "N"};
					userData["metaSearchJc"]["isMetaJcEnabled"] = userData["metaSearchJc"]["isMetaJcEnabled"] ? userData["metaSearchJc"]["isMetaJcEnabled"] : "N";
					userData["jioPhoneCallAI"] = userData["jioPhoneCallAI"] ? userData["jioPhoneCallAI"] : {};
					userData["isNewUserNotify"] = userData["isNewUserNotify"] ? userData["isNewUserNotify"] : 'N';
					if(!suc['isTwoFAEnabled']){
						delete userData["encTwoFASessionKey"];
					}

					if(!userData["jcEntInfo"]){
						userData["enableAdminConsole"] = false;
					}else if(userData["jcEntInfo"]){
						classRef.universalService.showFeaturesForEntUsers = true;
						if(userData["jcEntInfo"]["entUserRole"] == "A"){
							userData["enableAdminConsole"] = true;
						}else{
							userData["enableAdminConsole"] = false;
						}
					}
					localStorage.setItem('isMandatoryEmailActive'+ userData.userId, suc["isMandatoryEmail"]);
					AppEvents.updateAuthData.next({updateAuthData:true,userData:userData,"initiator":"user details"});
					classRef.universalService.setUpdateProfileIconPath();
					AppEvents.updateLeftMenuStorage.next({ updateLeftMenuStorage: true });
					classRef.checkIfCloudPCUser(userData);
					setTimeout(() => {
						classRef.checkIfPlanHasExpired(suc);
					}, 500);
					if(userData["privateFolder"]["isPPFEnabled"] == "Y" && userData["privateFolder"]["allowPPF"] == "Y"){
						classRef.universalService.fetchJSONContent();
					}
					resolve(suc);
				},
				(error:HttpErrorResponse) => {
					classRef.isOTPLoginError = true;
					classRef.universalService.showLoader = false;
					classRef.exception.handleLoginError('OTP',error)
					reject(false);
					
				},
			);
		})	
	}

	checkIfCloudPCUser(userData){
		if(userData["authProviderId"] == ENV_CONFIG["commonUrls"]["jiocloudpcAuthProviderId"] && userData["iframeLogin"] && !this.universalService.isMobileDevice){
			this.universalService.iframeLogin = true;
		}
	}

	setUserDetails(data,User_Device) { // sets user data in localstorage
		USER_DETAILS["USER_DETAILS"] = DEFAULT_USER_DETAILS;
		this.localStorageSvc.setDcGroupCode(data.dcGroupCode, true)
		this.sessionStorageService.setUserCookieExist("Y")
		let token = data['authToken'].accessToken;
		AppEvents.updateAuthData.next({updateAuthData:true,userData:data,"initiator":"userdetailsset"});
		this.universalService.resetValuesBeforeReLogin();
		var lastRefreshTime = new Date().getTime()
		this.localStorageSvc.setRefreshTokenTime(lastRefreshTime)
		if(data['recoverData']){
			this.localStorageSvc.setRecoverData(data['recoverData'], false);
		}else{
			this.localStorageSvc.setRecoverData(false, false);
		}
		data["quota"] = {"totalAllocatedQuota" : data.totalAllocatedQuota, "totalUsedQuota": data.totalUsedQuota};
		if(data['isTwoFAEnabled']){
			this.localStorageSvc.setTwoFAEnable("Y", true)
		}else{
			this.localStorageSvc.setTwoFAEnable("N", true)
		}
		
		this.universalService.setUpdateProfileIconPath();
		localStorage.setItem('isMandatoryEmailActive'+ data["userId"], data["isMandatoryEmail"]);
		localStorage.setItem('invokeAppEvent', "Y");

		this.cleverTapEventsService.setClearTapProfilePush(data.userId);
	}

	updateRefreshedTokens(data,checkFor2FA){
			var self=this;
			new Promise(function(resolve, reject){
				self.isTimeIntervalOverFor2FA(data);
				var userData = self.localStorageSvc.getUserData(true);
				if(data["jcJWT"]!=undefined){
					self.localStorageSvc.setLocalProperty (LocalStorageProps.JC_JWT,data["jcJWT"],false)
				}
				var authToken = {
					accessToken : data["accessToken"],
					expiresIn : data["expiresIn"],
					refreshToken : data["refreshToken"]
				}
				userData["authToken"] = authToken;
				userData["dcGroupCode"] = data["dcGroupCode"];
				userData = {
					...userData,
					...data
				};
				AppEvents.updateAuthData.next({updateAuthData:true,userData:userData,"initiator":"refresh token"});
				resolve(true);
			})
	}

	public ping(serviceUrl: string){ 
		var userData = this.localStorageSvc.getUserData(true);
		let expiresIn =  (userData != undefined) ? userData["authToken"]["expiresIn"] : '';

		if (expiresIn.length === 0) {
			expiresIn = 5;
		}
		let pingTime = (expiresIn / 3.2) * 1000;
		this.universalService.isPingEnabled=true;
		UniversalService.pingcall = setInterval(() =>{
			if(!document.hidden && !this.universalService.refreshTokenInprocess){
				this.http.get(serviceUrl).subscribe(
					(suc) => { 
					},
					(error) => {
						this.loggerService.log("ping fail")
					},
				);
			}
		}, pingTime)  
	}
	
	public  refreshData(serviceUrl: string,userType,lastRefresh,isStaySignIn){
		var classRef = this;
		if(this.universalService.inAppWebViewOpened) {
			return false;
		}
		return new Promise(async function(resolve, reject){
			var userData = classRef.localStorageSvc.getUserData(true);
			let currentTime = new Date().getTime();
			let hours = (currentTime - lastRefresh) / 3600000;
			//const expiresIn = classRef.localStorageSvc.getTokenExpiryDuration(true)/(1.2 * 60 * 60);
			const expiresIn = userData["authToken"]["expiresIn"]/(1.2 * 60 * 60);
			if ((lastRefresh!=null && hours > expiresIn) || classRef.universalService.invokeRefresh) { 
				let checkFor2FA = true;//passedTime.minute >= ENV_CONSTANTS["constants"]["Interval_2FA"]
				classRef.universalService.invokeRefresh = false;
				let isIdamOn = "true";
				if (userType != undefined && JSON.parse(userType).type == 'Jio') {
					isIdamOn = "true";
				} else {
					isIdamOn = "false";
				}
				const jToken = true;
				var refreshData = {
					"deviceType": "W",
					"jToken": jToken,
					"refreshToken": userData["authToken"]["refreshToken"],
					"isIdamOn":isIdamOn,
					"deviceInfo": {
						"model": "browser",
						"deviceName": "Web Device",
						"type": "browser",
						"isWebClient": true,
						"deviceKey": userData["deviceKey"]
					},
					isStaySignIn: isStaySignIn
				};

				let result = await classRef.refreshDataApi(serviceUrl,refreshData,checkFor2FA)
				resolve(true);
			}else{
				classRef.universalService.refreshTokenInprocess=false
				reject(false);
			}
		});
	}

	public refreshDataApi(serviceUrl,refreshData,checkFor2FA){
		var self = this;
		return new Promise(function(resolve, reject){
			self.http.put(serviceUrl,refreshData,{observe:'response'}).subscribe(
				async (suc) => {
					self.universalService.refreshTokenInprocess=false
					await self.updateRefreshedTokens(suc.body,checkFor2FA);
					await self.callAppEventsApi()
					resolve(true);

				},
				(error:HttpErrorResponse) => { 
					self.universalService.refreshTokenInprocess = false;
					reject(false);
				},
			);
		})
	}
	public async callAppEventsApi(){
		var userData = await this.getUserDetails();
		if(userData["metaSearchJc"]["isMetaJcEnabled"] == "N"){
			this.updateAppEvent(this.deviceService.browser,this.deviceService.browser_version)
		}
		return;
	}
	public  pingAndCookie(serviceUrl:string,cookieUrl:string){
		var self= this;
		return new Promise(function(resolve, reject){
			self.http.get(serviceUrl).subscribe(
					(suc) => { 
						if(cookieUrl!=null){
							self.http.get(cookieUrl).subscribe(
								(suc) => { 
									resolve(true);
								},
								(error) => {
									reject(false);
								},
							);
						}else{
							resolve(true);
						}
						
					},
					(error) => {
						reject(false);
					},
				);
		});
	}


	createDeviceKey() {
    var dt = new Date().getTime();
    var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (dt + Math.random() * 16) % 16 | 0;
      dt = Math.floor(dt / 16);
      return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
    this.qrDeviceKey = uuid;
	}
	
  	public  async getQRImage(serviceUrl: string,browser: any,browserVersion: any,qrLoginUrl:any) {
		this.refreshQRCode = false;
		var params = {
			"deviceType": "W",
			"deviceInfo": {
				"deviceKey": this.qrDeviceKey,
				"platformType": browser,
				"platformVersion": browserVersion,
				"model": "browser",
				"deviceName": "Web Device",
				"type": "browser",
				"isWebClient": true
			}
    }	
    var response = await this.getQRImageApi(serviceUrl,params,browser,browserVersion,qrLoginUrl);
	return response;
	}

	public  getQRImageApi(serviceUrl,params,browser,browserVersion,qrLoginUrl){
		var self = this;
		return new Promise(function(resolve,reject){
		self.http.post(serviceUrl, params).subscribe(
			qrCodeResp => {
				self.qrCodeInvalid = false;
				self.refreshQRCode = false;
				self.qrImageUrl = qrCodeResp["qrUnique"];
				UniversalService.qrValidationInterval = setInterval(()=>{
					self.validateQrCode();
				},60000)
				resolve(self.qrImageUrl)
			},
			qrCodeErr => {
				self.refreshQRCode = true;
				self.exception.handleLoginError('QR',qrCodeErr);
				reject(qrCodeErr)
				}
			)
		})
	}


	public qrLogin(qrLoginUrl,browser,browserVersion){
		var params = {
      "qrUnique": this.qrImageUrl,
      "deviceType": "W",
      "deviceInfo": {
        "model": "browser",
        "deviceName": "Web Device",
        "deviceKey": this.qrDeviceKey,
        "platformType": browser,
        "platformVersion": browserVersion,
        "type": "browser",
        "isWebClient": true
      }
		}
		var response = this.qrLoginApi(qrLoginUrl,params);
		return response;
  }

	public qrLoginApi(qrLoginUrl,params){
		var self = this;
		return new Promise(function(resolve,reject){
		self.http.post(qrLoginUrl, params,{observe: 'response'}).subscribe(
			async qrLoginResp => {
						clearInterval(UniversalService.qrLoginInterval);
						clearInterval(UniversalService.qrValidationInterval);
						self.localStorageSvc.removeLocalProperty(LocalStorageProps.JC_JWT)
						localStorage.setItem("userType", JSON.stringify({type: "Jio",obj: ""}));
						self.setUserDetails(qrLoginResp.body,qrLoginResp.headers.get("User-Device"));
						self.localStorageSvc.setLastUserMovementTime(new Date().getTime());
						if(qrLoginResp.body?.jcJWT!=undefined){
							self.localStorageSvc.setLocalProperty (LocalStorageProps.JC_JWT,qrLoginResp.body?.jcJWT,false)
						}
						self.cleverTapEventsService.loginMode();	
						self.cleverTapEventsService.qrLogin();
						self.cleverTapEventsService.loginStatus(); 
						resolve(qrLoginResp)
			},
			qrLoginErr => {
				self.universalService.showLoader = false;
				
				if(qrLoginErr["error"]["code"]=="SCLN0307"){
					self.qrCodeInvalid = true;
				}else{
					self.refreshQRCode = true;
					clearInterval(UniversalService.qrValidationInterval);
					clearInterval(UniversalService.qrLoginInterval)						
				}
				reject("qrLoginErr");
			}
    	)
		})
	}

	public validateQrCode(){
    if(this.qrCodeInvalid){
			this.refreshQRCode = true;
			this.loggerService.log("refresh qr code is",this.refreshQRCode)
    }
    clearInterval(UniversalService.qrValidationInterval);
    clearInterval(UniversalService.qrLoginInterval)
	}
	
	public logout(serviceUrl,device){
		var self = this;
		var appName = device ? device["appName"] : "JioAICloud"; 
		var atoken = localStorage.getItem("atoken")
		if(atoken){
			var url = 'https://accounts.google.com/o/oauth2/revoke?token=' + atoken;
			globalThis.fetch(url);
		}
		return new Promise(function(resolve, reject){
			var logoutData = {
				"revokeAll": "N",
				"forceLogout": "N",
				"devices": [{
					"deviceKey": (device != undefined) ? device["deviceKey"] : "",
					"appName": appName,
				}]
			}
			self.http.put(serviceUrl,logoutData).subscribe(
				async (suc) => {
					resolve(true);
				},
				(error:HttpErrorResponse) => {
					self.loggerService.log(error);
					reject(false);
				},
			);
		})
		
	}

	twoFALogout(serviceUrl,deviceId){
		var self = this;
		return new Promise(function(resolve, reject){
			var logoutData = {
				"revokeAll": "N",
				"forceLogout": "N",
				"devices": [{
					//"deviceKey": self.localStorageSvc.getDeviceKey(true),
					"deviceKey": USER_DETAILS["USER_DETAILS"]["deviceKey"],
					"appName": "JioCloud",
				}]
			}
			self.http.put(serviceUrl,logoutData).subscribe(
				async (suc) => {
					resolve(true);
				},
				(error:HttpErrorResponse) => {
					self.loggerService.log(error);
					reject(false);
				},
			);
		})
	}

	genratePassPhraseHash(passPhrase){
		this.universalService.twoFAHash = this.passwordEncryptorUtil.getHash(USER_DETAILS["USER_DETAILS"]["userId"],passPhrase);////userId,passPhrase
		return true;
  	}

	
		
	async getCustomePassPhraseHeader(){
		let userID = USER_DETAILS["USER_DETAILS"]["userId"];// this.localStorageSvc.getUserId(true);
		let currentTime = new Date();
		let twoFAHash = this.universalService.twoFAHash;
		let StringToEncrypt = userID + '#' + twoFAHash+ '#' + currentTime.getTime();
		let decrypted2FASessionKey = await this.decrpytTwoFASessionKey();
		let decrypted2FASessionKeyArray = decrypted2FASessionKey.split('#');
		if(decrypted2FASessionKeyArray.length == 1){
			this.invalidPassPhrase = true;
			return;
		}
		this.universalService.enc2FAHash = await this.encrpyptPassPharse(StringToEncrypt,decrypted2FASessionKeyArray[1]);
	}

	async decrpytTwoFASessionKey(){
		var userData = this.localStorageSvc.getUserData(true);
		let encryptedTwoFASessionKey = userData["encTwoFASessionKey"];
		return await this.passwordEncryptorUtil.decryptTwoFASessionKey(encryptedTwoFASessionKey , this.universalService.twoFAHash)
	}

	async encrpyptPassPharse(StringToEncrypt,twoFASessionkey){
		return await this.passwordEncryptorUtil.encryptPassPhrase(StringToEncrypt, twoFASessionkey)
	}
	
	async validate2FA(url){
		var classRef = this;
		this.invalidPassPhrase = false;
		await classRef.getCustomePassPhraseHeader();
		return new Promise(function(resolve, reject){
			if(classRef.invalidPassPhrase ){
				localStorage.setItem("passPhraseValidationSuccess", 'false')
				localStorage.setItem('invalidPassPhraseCounter',classRef.invalidPassPhraseCounter);
				classRef.manageInvalidPassPhraseAttempts();
				classRef.isPassPhraseLoginError = true;
				classRef.enablePassPhraseSubmitButton = false;
				classRef.exception.handleLoginError('PASSPHRASE',JSON.parse('{"error":{ "code": "SCLN0140" }}'))
				reject(false);
			}else{
				classRef.http.get(url).subscribe(
					(suc) => { 
						let userData = classRef.localStorageSvc.getUserData(true);
						userData["2FAValidated"] = true;
						AppEvents.updateAuthData.next({updateAuthData:true,userData:userData,"initiator":"validate 2FA"});
						localStorage.setItem("passPhraseValidationSuccess", 'true')
						classRef.universalService.show2FApopUp = false;
						if(!classRef.universalService.showPromotionsList && !classRef.universalService.showEnhancedShareLink && !classRef.universalService.showBlockingBannerModal){
							if(classRef.universalService.popUpToBeOpened != "dummy" && classRef.universalService.popUpToBeOpened != 'addToAlbum'){ // pop up name is set to dummy, when a popup is opened
								classRef.universalService.disableModalBackdrop();
							}
						}
						classRef.invalidPassPhraseCounter = ENV_CONSTANTS["constants"]["passPhraseattempts"];
						classRef.isPassPhraseLoginError = false;
						localStorage.setItem('invalidPassPhraseCounter',classRef.invalidPassPhraseCounter);
						let cTime = new Date().getTime()+5000
						classRef.localStorageSvc.setLastUserMovementTime(cTime,false);
						resolve('Success');
					},
					(error:HttpErrorResponse) => {
						console.log(error);
						classRef.universalService.showLoader = false;
						let cTime = new Date().getTime()+5000
						classRef.localStorageSvc.setLastUserMovementTime(cTime,false);
		
						if (error.error.code == "SCLN0147"){
							classRef.universalService.show2FApopUp = false;
							if(!classRef.universalService.showPromotionsList){
								classRef.universalService.disableModalBackdrop();
							}
							classRef.localStorageSvc.setTwoFAEnable("N", true)
							localStorage.removeItem('passPhraseValidationSuccess');
							classRef.isPassPhraseLoginError = false;
							resolve('Success');
						}else{
							localStorage.setItem("passPhraseValidationSuccess", 'false')
							localStorage.setItem('invalidPassPhraseCounter',classRef.invalidPassPhraseCounter);
							classRef.manageInvalidPassPhraseAttempts();
							classRef.isPassPhraseLoginError = true;
							classRef.enablePassPhraseSubmitButton = false;
							if(error.error.code != "TEJGA0401")
								classRef.exception.handleLoginError('PASSPHRASE',error)
							reject(false);
						}
						
						
					},
				);
			}
			
		})	
		
	}

	async check2FAStatus(isTwoFAEnabled){
		let self =  this
		if( isTwoFAEnabled == true){ //this.router.url.indexOf("?u") == -1 &&
			if(self.universalService.activeRepo == ActiveRepo.SHARE ){
				self.universalService.fetchLeftMenuJSONContents();
			}
			self.universalService.showLoader = false; 
			self.universalService.show2FApopUp = true
			self.universalService.showLoader= false;
		}else{
			self.universalService.show2FApopUp = false;
			//$('#custome_backdrop').remove();
			// await self.getUserDetails();
		}
	}

	manageInvalidPassPhraseAttempts(){
		if(localStorage.getItem('invalidPassPhraseCounter')!=undefined && localStorage.getItem('invalidPassPhraseCounter') != null){
			this.invalidPassPhraseCounter = JSON.parse(localStorage.getItem('invalidPassPhraseCounter'))
		}
		this.invalidPassPhraseCounter--;
		localStorage.setItem('invalidPassPhraseCounter',this.invalidPassPhraseCounter);
		if(this.invalidPassPhraseCounter == 0 || this.invalidPassPhraseCounter < 0){
			
			// confirm("Any more failed attempt will lock the application for 10 minutes")
			this.invalidPassPhraseCounter = 0;
			let currentDate = new Date();
			let lockTime = currentDate.getTime().toString()
			let unlockTime = (currentDate.getTime() + (10 * 60 * 1000)).toString()
			localStorage.setItem("appLockTime",lockTime);
			localStorage.setItem("appunlockTime",unlockTime)
			this.enablePassPhraseSubmitButton = false;
			this.resetInavlidPassPhraseCounter();
		}
	}

	resetInavlidPassPhraseCounter(){
		this.startTimer();
		var interval = setInterval(() => {
			let currentDate = new Date();
			let currentTime = currentDate.getTime();
			let unlockTime =  JSON.parse(localStorage.getItem('appunlockTime'))
			if(currentTime == unlockTime || currentTime > unlockTime){
				this.invalidPassPhraseCounter = ENV_CONSTANTS["constants"]["passPhraseattempts"];
				localStorage.removeItem('passPhraseValidationSuccess');
				localStorage.setItem('invalidPassPhraseCounter',this.invalidPassPhraseCounter);
				this.enablePassPhraseSubmitButton = false;
				this.isPassPhraseLoginError = false;
				$("#passPhraseInput").val("");
				localStorage.removeItem("appLockTime");
				localStorage.removeItem("appunlockTime");
				clearInterval(interval);
			}
		}, 1000);
	}
	
	startTimer(){
		interval(1000).subscribe(x => {
			this.getTimeDifference()
		})
	}

	getTimeDifference () {
		let dDay =  JSON.parse(localStorage.getItem('appunlockTime'))
		let timeDifference;
        timeDifference = dDay - new  Date().getTime();
        this.allocateTimeUnits(timeDifference);
    }

  	allocateTimeUnits (timeDifference) {
		let self = this;
		let milliSecondsInASecond = 1000;
		let minutesInAnHour = 60;
		let SecondsInAMinute  = 60;
		let secondsToDday;
    	let minutesToDday;
		let dispayTime;
        secondsToDday = Math.floor((timeDifference) / (milliSecondsInASecond) % SecondsInAMinute);
        minutesToDday = Math.floor((timeDifference) / (milliSecondsInASecond * minutesInAnHour) % SecondsInAMinute);
		
		if(minutesToDday < 10 && secondsToDday >= 10){
			dispayTime = "0" + minutesToDday + ":" + secondsToDday
		}else if (minutesToDday >= 10 && secondsToDday < 10){
			dispayTime = minutesToDday + ":" + "0" +secondsToDday
		}else if (minutesToDday < 10 && secondsToDday < 10){
			dispayTime = "0" +minutesToDday + ":" + "0" +secondsToDday
		}
		self.universalService.lockTimer = dispayTime;
  }


	
  async isTimeIntervalOverFor2FA(suc){ 
	var checkLogin =localStorage.jio;
    let currentTme = new Date().getTime();//current time
    let lastUserMovementTime = this.localStorageSvc.getLastUserMovementTime(false)-5000;//last api call time
    let time = lastUserMovementTime ? lastUserMovementTime : currentTme
    let timeDifference= currentTme - time//differance between cuurent time last api call time
    let passedTime = this.universalService.msToTime(timeDifference);//fetch min. value from millieseconds
	if( checkLogin && this.universalService.isStreaming == false){
		if(suc['isTwoFAEnabled']){
			this.localStorageSvc.setTwoFAEnable("Y", true)
		}else{
			this.localStorageSvc.setTwoFAEnable("N", true)
		}
    }
  }

  getAutoLogionToken(serviceUrl){
	let self = this;
	let param = {
		type:"promo"
	}
	return new Promise(function(resolve, reject){
		self.http.get(serviceUrl).subscribe(
			async (suc) => {
				resolve(suc);
			},
			(error:HttpErrorResponse) => {
				reject(false);
			},
		);
	})
  }

  validateDirectLoginToken(serviceUrl, params, deviceKey) {
	var classRef = this;
	return new Promise( (resolve, reject) => {
		classRef.http.post(serviceUrl, params,{observe: 'response'}).subscribe(
			(res:Response) => { 
				let userId = res.headers.get('X-User-Id');
				let deviceKey = res.headers.get('User-Device');
				res["userId"] = userId ? userId : null;
				res["deviceKey"] = deviceKey ? window.atob(deviceKey) : null;
				AppEvents.updateAuthData.next({"updateProperty":true,"property":{"key":"userId","value":userId}});
				AppEvents.updateAuthData.next({"updateProperty":true,"property":{"key":"deviceKey","value":window.atob(deviceKey)}})
				resolve(res);
			},
			error => {
				reject(error);
				
			},
		);	
	})
  }

  checkIfPlanHasExpired(suc){
	  if(suc["allowStoragePurchase"] == "Y" && suc["paidPlan"]){
		var expiryTime = suc["paidPlan"]["endDate"];
		var exp = new Date(expiryTime);
		var date =  exp.getDate() + "/" + ((exp.getMonth()+1) >= 10 ? (exp.getMonth()+1) : ("0"+(exp.getMonth()+1))) + "/" + exp.getFullYear();
		if(suc["paidPlan"]["planStatus"] == "E" || suc["paidPlan"]["planStatus"] == "G"){
			BANNER_CONSTANTS["PLAN_EXPIRY"]["bannerTxt"] = BANNER_CONSTANTS["PlanExpiryText"] + date; 
			BANNER_CONSTANTS["PLAN_EXPIRY"]["bannerIconType"] = "Neuewarning-new";
			AppEvents.bannerEvent.next(BANNER_CONSTANTS.PLAN_EXPIRY);
		}else if(suc["paidPlan"]["planStatus"] == "A"){
			BANNER_CONSTANTS["PLAN_EXPIRY"]["bannerTxt"] = "Removing banner"; 
			AppEvents.bannerEvent.next(BANNER_CONSTANTS.STORAGE_BANNER);
		}
	  }
  }
  checkIsTroubleInSigningIn(errorResponse,mobileNumber){
	this.troubledLoginMobileNo = mobileNumber;
	if(errorResponse.error.code == 'SCLN0032'){
		this.universalService.showTroubledSignInLink= true;
	}
  }

  troubledLoginErrorCode:any = "";
  troubledLogin(serviceUrl,mobileNumber){
	var classRef = this;
	this.troubledLoginErrorCode = ""
	//classRef.troubledLoginMobileNo = '';
	var params = {}
	if(mobileNumber){
		params["mobileNumber"] = mobileNumber;
	}
	return new Promise( (resolve, reject) => {
		classRef.http.post(serviceUrl, params).subscribe(
			(res:Response) => { 
				classRef.cleverTapEventsService.troubleLoginTap();
				resolve(res);
			},
			error => {
				this.troubledLoginErrorCode = error.error.code;//SCLN0311 SCLN0110
				classRef.cleverTapEventsService.troubleLoginTapError(error.error);
				reject(error);
				
			},
		);	
	})
  }

	recoverAccount(serviceUrl, params) {
			var classRef = this;
			return new Promise( (resolve, reject) => {
				classRef.http.post(serviceUrl, params).subscribe(
					(res) => { 
							classRef.emailId = res['emailId'];
							setTimeout(() => {
								classRef.universalService.showLoader = false; 
							classRef.universalService.showRecoverVerifyemailpopUp =  true;
							classRef.universalService.showRecoverpopUp = false;
							classRef.universalService.showLoader= false;
							classRef.universalService.customerTroubleLogin = true;

							}, 100);

							
				

						resolve(res);
					},
					error => {
						classRef.reqIdFromResponseHeader = error.headers.get("X-Request-Id");
						classRef.noMappingFoundModal = true
						classRef.universalService.customerTroubleLogin = true;
						classRef.localStorageSvc.setRecoverDataError(true, false);
						classRef.universalService.showRecoverpopUp =  false;
						reject(error);
						
					},
				);	
			})
		}

		sendOTPForRecoverAccount(serviceUrl,params){
			var classRef = this;
			window.clearInterval(classRef.universalService.OtpInterval)
			return new Promise( (resolve, reject) => {
				classRef.http.post(serviceUrl, params).subscribe(
					(res) => { 
						if (res == null) {
						classRef.universalService.showLoader = false; 
						classRef.universalService.showRecoverVerifyemailpopUp =  false;
						classRef.router.navigate(['/signin']);
						classRef.universalService.customerTroubleLogin = true;
							classRef.exception.errorMessage = "";
							var count = 30;
							classRef.enableButton = false;
							classRef.showTimer = true;
							classRef.universalService.OtpInterval = setInterval(() => {
								count = count - 1;
								if (count != 0) {
									classRef.OTPTimer = count;
								} else {
									classRef.showTimer = false;
									classRef.OTPTimer = 0;
									window.clearInterval(classRef.universalService.OtpInterval)
								}
							}, 1000)
						}
						resolve(res);
					},
					error => {
						classRef.isOTPLoginError = true;
						classRef.exception.handleLoginError('OTP',error)
						reject(error);
					},
				);	
			})
		}

		validateOTPForRecoverAccount(serviceUrl,params){
			var classRef = this;
			return new Promise( (resolve, reject) => {
				classRef.http.post(serviceUrl, params,{observe: 'response'}).subscribe(
					(res:Response) => { 
							classRef.mobileNumber = classRef.localStorageSvc.getRecoverDataMobile(false);
							classRef.universalService.showLoader = false; 
							classRef.universalService.recoverVerifyOTPpopUp =  true;
							classRef.universalService.showRecoverpopUp = false;
							classRef.universalService.customerTroubleLogin = true;
							classRef.cleverTapEventsService.emailVerifySuccess('Account_change');
						resolve(res);
					},
					error => {
						classRef.isOTPLoginError = true;
						setTimeout(function() {
							(<HTMLInputElement>document.getElementById("digit1")).focus();
							}, 500);
							classRef.cleverTapEventsService.emailVerifyError(error,'Account_change')
						classRef.exception.handleLoginError('OTP',error)
						reject(false);
						
					},
				);	
			})
		}

		versionAPI(serviceUrl){
			var classRef = this;
			return new Promise(function(resolve, reject){
				classRef.http.get(serviceUrl).subscribe(
					(suc) => {
						// suc["disableBusinessLogin"] = true;
						classRef.versionDetails = suc;
						resolve(suc);		
					},
					(error:HttpErrorResponse) => {
						classRef.versionDetails = {"disableBusinessLogin":false};
						reject(error);
					},
				);
			})
		}

		disconnectMSOffice(url,consent){
			var self = this;
			let params = {
				"isMSConsent": consent
			}
			return new Promise(function(resolve, reject){
				self.http.put(url,params).subscribe(
					suc => {
						return resolve({"consentUpdated":true});
					},
					error => {
						console.log("error in updating MS consent",error);
						return reject(error);
					},
				);
			})
		}

		getDocumentSupportedFormats(){
			var self = this;
			const serviceUrl = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["baseURL"] +  ENV_CONFIG.commonUrls["docSupportedFormats"]; 
			this.http.get(serviceUrl).subscribe(
				suc => {
					self.universalService.docEditSupportedExtensions = suc;
				},
				error => {
					console.log("error in fetch supported extensions from server",error);
				}
			)
		}

		getFullScreenBannerDetails(){
			var self = this;
			const serviceUrl = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["msgCallLogURL"] +  ENV_CONFIG.commonUrls["getFullScreenBannerDetails"]; 
			this.http.get(serviceUrl).subscribe(
				suc => {
					self.universalService.fullScreenBannerDetails = suc;
					return suc;
				},
				error => {
					console.log("error in fetching banner details from server",error);
				}
			)
		}

		submitBannerAction(action,cardUniqueCode){
			var self = this;
			const serviceUrl = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["msgCallLogURL"] +  ENV_CONFIG.commonUrls["fullScreenBannerAction"]; 
			let params ={
				"featureCode" : "BANNER",
				"cardUniqueCode": cardUniqueCode,
				"cardActionDate":  Date.now(),
				"cardActionCode": action 
			}
			self.http.post(serviceUrl, params).subscribe(
				suc => {
					AppEvents.globalObservable.next({"fullScreenBannerClose":true});
					return suc;	
				},
				(error:HttpErrorResponse) => {
					// self.universalService.showToast(LOGIN_ERROR.BannerApiError, "error")
					AppEvents.globalObservable.next({"fullScreenBannerClose":true});
					return error;
				},
			);
		}

		public  getCookie(cookieUrl:string){
			var self= this;
			return new Promise(function(resolve, reject){
				self.http.get(cookieUrl).subscribe(
					(suc) => { 
						self.sessionStorageService.setUserCookieExist("Y")
						resolve(true);
					},
					(error) => {
						reject(false);
					},
				);
			});
		}


		public  updateAppEvent(browser,browserVersion) {
			var classRef = this;
			let userData = this.localStorageSvc.getUserData(true);
			let eventUrl = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] + ENV_CONFIG.commonUrls["appEvent"];

			return new Promise(async function(resolve, reject){
						var params = {
								"xClientDetails": ENV_CONSTANTS.envHeaders[GlobalClassInstance.ENV_NAME]["X-Client-Details"],
								"appInfo":{
									"appName": "JC",
									"clientVersion": versionData.appVersion
								},
								"deviceInfo": {
									"platformType": browser,
									"platformVersion": browserVersion,
									"model": "browser",
									"deviceName": "Web Device",
									"deviceType" : "W",
									"deviceKey": userData["deviceKey"],
								},
								"appEvents":  [
									{
										"eventName":"APP_LAUNCH",
										"eventType":"system",
										"attribute" : {
											"launch": "forground"
										}
									},
									{
										"eventName":"APP_INFO",
										"eventType":"systemuser"
									}
      							]
												
							}
					try{
						classRef.http.post(eventUrl,params).subscribe(
							suc=>{
							  console.log("updateAppEvent suc::",suc)
							  resolve(suc);
							},
							err=>{
							  console.log("updateAppEvent err::",err)
							  reject(false);
							}
						  )
						
						
					}catch(e){
						console.log("updateAppEvent e::",e)
						reject(false);
					}
					
						  

			});
		}
	
}
